<template>
    <div class="modal fade show d-block" tabindex="-1" role="dialog" >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('default.add')}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$close()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">

            <v-wait for="add">

                <loading slot="waiting"/>

                <form @submit.prevent="validate_add">


                    <div class="form-group">

                        <label for="name">{{ $t('simple.name') }}</label>

                        <input
                            class="form-control"
                            type="text"
                            id="name"
                            name="name"
                            v-validate="'required|max:15'"
                            v-model="name"
                        >

                        <small v-show="errors.has('name')" class="form-text text-danger"><font-awesome-icon :icon="'times-circle'" /> {{ errors.first('name') }}</small>

                    </div>

                    <div class="form-group">

                        <label for="description">{{ $t('simple.desc') }}</label>

                        <input 
                            class="form-control"
                            type="text"
                            id="description"
                            name="description"
                            v-validate="'required|max:50'"
                            v-model="description"
                        >

                        <small v-show="errors.has('description')" class="form-text text-danger"><font-awesome-icon :icon="'times-circle'" /> {{ errors.first('description') }}</small>

                    </div>

                </form>

            </v-wait>

        </div>

        <div class="modal-footer">

            <b-button @click="$close(false)" variant="secondary">{{ $t('simple.cancel') }}</b-button>
            <div v-b-tooltip.hover.right="{
                 title:!user_permissions.includes('create-customer-genders')? $t('permission.permission_denied', { permission: 'create-customer-genders' }) : '',customClass: 'tooltip-dark' }"
                 style="display: inline-block">
              <b-button @click="validate_add()" variant="primary" :class="!user_permissions.includes('create-customer-genders') ? 'cursor-not-allowed' : ''"
                        :disabled="!user_permissions.includes('create-customer-genders')">{{ $t('simple.save') }}</b-button>
            </div>
        </div>


        </div>
      </div>
    </div>
</template>
<script>

    import {mapGetters} from "vuex";

    export default {

        mounted: function () {
            // Component mounted
            console.log('Customer Gender Add Modal mounted');
        },
        
        destroyed() {
            // Component destroyed
            console.log('Customer Gender Add Modal destroyed.');
        },

        data: function() {
            return  {
                customer_genders_api: '/api/v1/settings/customer/genders/',
                name: '',
                description: '',
            }
        },

        methods: {
            customer_gender_add: async function(){

                // Loading start
                this.$wait.start('add');
                
                // Post request
                await axios.post(this.customer_genders_api, {
                    name: this.name,
                    description: this.description,
                  })
                  .then((response) => {

                    Vue.toasted.success(this.$t('simple.success_info'));
                    // Close modal
                    this.$close(true);

                    // Loading end
                    this.$wait.end('add');


                  })
                  .catch((error) => {
                    if (error.response && error.response.status === 403) {
                      Vue.toasted.error(this.$t('permission.permission_denied',{ permission: 'create-customer-genders'}));
                    } else {
                      Vue.toasted.error(this.$t('simple.error_info'));
                    }
                    // Log to console
                    console.log(error);

                    // Close modal
                    //this.$close(true);
                    
                    // Loading end
                    this.$wait.end('add');


                  });

            },
            

            validate_add: async function() {
                // validate all fields
                await this.$validator.validateAll().then((result) => {
                    if (result) {
                        // Send it to account edit function
                        this.customer_gender_add();
                    }
                });
            },
        },
      computed: {
        // Map getters
        ...mapGetters({
          user_permissions: 'User/getUserPermissions'
        })
      },
    }
</script>